import { render, staticRenderFns } from "./CustomizedMenuProps.vue?vue&type=template&id=30a98af4&"
import script from "./CustomizedMenuProps.vue?vue&type=script&lang=js&"
export * from "./CustomizedMenuProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports